import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi, OperatoriApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { DataGrid, Column, LoadPanel, Scrolling, Selection } from 'devextreme-react/data-grid';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
import { isUndefined } from 'util';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import EmergenzaCreatePopup, { EmergenzaCreatePopupHandle } from './EmergenzaCreatePopup';
import { useFilterByFilterIdDataSource } from '../../datasources/FilterBuilderDataSource';

type Props = {
  filterId?: string,
  emergenzaIdToExclude?: string
}

export type EmergenzaFilterPreviewPanelHandle = {
}

type state = {
}

const EmergenzaFilterPreviewPanel: React.ForwardRefRenderFunction<EmergenzaFilterPreviewPanelHandle, Props> = (props, ref) => {
  return (
    <React.Fragment>
      <h4>Anteprima filtro</h4>

      <DataGrid
        dataSource={useFilterByFilterIdDataSource(props.filterId)}
        showBorders={true}
        hoverStateEnabled={true}
        height={'100%'}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        remoteOperations={false}
        customizeColumns={(columns) => {
          // Nascondiamo le colonne assistitoId e tenantId (come in AnteprimaFiltro)
          columns.forEach(column => {
            if (column.dataField) {
              const fieldName = column.dataField.toLowerCase();
              if (fieldName === 'tenantid' || fieldName === 'assistitoid') {
                column.visible = false;
              }
            }
          });
        }}
        noDataText={props.filterId ? "Nessun dato disponibile per questo filtro." : "Seleziona un filtro per visualizzare l'anteprima."}
      >
        <LoadPanel enabled={true} />
        <Scrolling mode="virtual" />
        {/* Le colonne sono generate automaticamente dal datasource */}
      </DataGrid>

    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaFilterPreviewPanel);